export default "__VITE_ASSET__69004cc7__"